import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('views/home'),
  },
  // 学习计划
  {
    path: '/plan',
    name: 'plan',
    component: () => import('views/plan'),
  },
  {
    path: '/plan/:professionId',
    name: 'planHome',
    component: () => import('views/plan/home'),
  },
  {
    path: '/plan/:professionId/:planType',
    name: 'planIntro',
    component: () => import('views/plan/intro'),
  },
  {
    path: '/plan/:professionId/:planType/start',
    name: 'planStart',
    component: () => import('views/plan/start'),
  },
  // 教师团队
  {
    path: '/teacher',
    name: 'teachers',
    component: () => import('views/teacher'),
  },
  {
    path: '/teacher/:teacherId',
    name: 'teacher',
    component: () => import('views/teacher/each'),
  },
  // 必刷知识点
  {
    path: '/know',
    name: 'know',
    component: () => import('views/know'),
  },
  {
    path: '/know/list/:courseId',
    name: 'knowList',
    component: () => import('views/know/list'),
  },
  {
    path: '/know/sample/:courseId',
    name: 'knowSample',
    component: () => import('views/know/sample'),
  },
  {
    path: '/know/detail',
    name: 'knowDetail',
    component: () => import('views/know/detail'),
  },
  // 免费领课
  {
    path: '/video',
    name: 'video',
    component: () => import('views/video'),
  },
  {
    path: '/video/:videoId',
    name: 'videoLearn',
    component: () => import('views/video/learn'),
  },
  // 历年真题
  {
    path: '/exam/:professionId',
    name: 'exam',
    component: () => import('views/exam'),
  },
  {
    path: '/analysis/:sectionId',
    name: 'analysis',
    component: () => import('views/exam/analysis'),
  },
  // 精选试题
  // {
  //   path: '/testpaper',
  //   name: 'testpaper',
  //   component: () => import('views/testpaper'),
  // },
  // {
  //   path: '/testpaper/:sectionId',
  //   name: 'testpaper-learn',
  //   component: () => import('views/testpaper/learn'),
  // },
  // 联系我们
  {
    path: '/contact',
    name: 'contact',
    component: () => import('views/contact'),
  },
  // 公开课
  {
    path: '/openclass/:professionId',
    name: 'openClass',
    component: () => import('views/open-class'),
  },
  // APP下载
  {
    path: '/download',
    name: 'download',
    component: () => import('views/download'),
  },
  {
    path: '/download/jiumingdaocao',
    name: 'jmdcDownload',
    component: () => import('views/download/jmdc'),
  },
  {
    path: '/download/baitongzaixian',
    name: 'btzxDownload',
    component: () => import('views/download/btzx'),
  },
  {
    path: '/download/xuesongketang',
    name: 'xsktDownload',
    component: () => import('views/download/xskt'),
  },
  {
    path: '/download/bintujiaoyu',
    name: 'btDownload',
    component: () => import('views/download/bt'),
  },
  {
    path: '/download/web/:name',
    name: 'webDownload',
    component: () => import('views/download/web'),
  },
  // 课程试听
  {
    path: '/audit',
    name: 'audit',
    component: () => import('views/audit'),
  },
  {
    path: '/audit/detail/:listenIndexId',
    name: 'auditDetail',
    component: () => import('views/audit/detail'),
  },
  // 404
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
